// import React, { useState, useEffect } from "react";
// import API from "../Context/api";
// import AddUserForm from "./AddUserForm";
// import EditUserForm from "./EditUserForm";
// import Spinner from "../Helpers/Spinner";
// import { useAuth } from "../Context/AuthContext";

// function Users() {
//   const [users, setUsers] = useState([]);
//   const [userToDelete, setUserToDelete] = useState(null);
//   const [userToEdit, setUserToEdit] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false); // Add user modal
//   const [modalOpen, setModalOpen] = useState(false); // Delete confirmation modal
//   const [modalOpenEdit, setModalOpenEdit] = useState(false); // Edit user modal
//   const [isShowTasks, setIsShowTasks] = useState(false);

//   const [isDeleting, setIsDeleting] = useState(false);
//   const [selectedTasks, setSelectedTasks] = useState([]);
//   const [currentUserName, setCurrentUserName] = useState("");

//   const { user } = useAuth();
//   const isAdmin = user?.role === "Admin";

//   // Fetch all users with their assigned tasks
//   const fetchUsers = async () => {
//     try {
//       const response = await API.get("/users"); // Updated to match backend route
//       setUsers(response.data);
//       console.log(response.data);
//       setLoading(false);
//     } catch (error) {
//       setError("Failed to fetch users");
//       setLoading(false);
//       console.error("Error fetching users:", error);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleOpenTasksModal = async (userId) => {
//     try {
//       const res = await API.get(`/users/tasks/${userId}`);
//       const user = users.find((u) => u.id === userId);
//       setCurrentUserName(user?.name || "User");
//       setSelectedTasks(res.data);
//       setIsShowTasks(true);
//     } catch (err) {
//       console.error("Failed to fetch tasks:", err);
//       setSelectedTasks([]);
//       setIsShowTasks(true);
//     }
//   };

//   const handleCloseTaskModal = () => {
//     setIsShowTasks(false);
//     setSelectedTasks([]);
//     setCurrentUserName("");
//   };

//   // Open delete confirmation modal
//   const handleDeleteClick = (id) => {
//     setUserToDelete(id);
//     setModalOpen(true);
//   };

//   // Close delete confirmation modal
//   const closeModal = () => {
//     setModalOpen(false);
//     setUserToDelete(null);
//   };

//   // Delete user
//   const handleDeletePost = async () => {
//     setIsDeleting(true);
//     if (userToDelete) {
//       try {
//         await API.delete(`/users/${userToDelete}`); // Assumes a delete endpoint exists
//         setUsers(users.filter((user) => user.userId !== userToDelete)); // Filter by SharePoint item ID
//         closeModal();
//       } catch (error) {
//         console.error("Error deleting user:", error);
//         alert("Failed to delete user.");
//         closeModal();
//       } finally {
//         setIsDeleting(false);
//       }
//     }
//   };

//   // Open edit modal
//   const handleEditPost = (id) => {
//     setUserToEdit(id);
//     setModalOpenEdit(true);
//   };

//   // Handle search input change
//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   // Filter users based on search query (by name)
//   const filteredUsers = users.filter((user) =>
//     user.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Open add user modal
//   const handleAddUser = () => {
//     setIsModalOpen(true);
//   };

//   const handleUserAdded = (updatedUser) => {
//     if (updatedUser.userId === userToEdit) {
//       // Edit case: Update existing user, preserving assignedTasks
//       setUsers(
//         users.map((user) =>
//           user.userId === updatedUser.userId
//             ? { ...user, ...updatedUser } // Merge existing user with updatedUser
//             : user
//         )
//       );
//     } else {
//       // Add case: Append new user
//       // Add case: Append new user, ensure assignedTasks exists
//       const newUser = {
//         ...updatedUser,
//         assignedTasks: updatedUser.assignedTasks || [], // Add empty array if missing
//       };
//       setUsers((prevUsers) => [...prevUsers, newUser]);
//     }
//     setIsModalOpen(false); // Close add modal
//     setModalOpenEdit(false); // Close edit modal
//     setUserToEdit(null); // Reset edit state
//   };

//   // if (loading) return <Spinner />;

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-full">
//         <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
//       </div>
//     );
//   }

//   if (error) return <div className="text-red-500 text-center">{error}</div>;

//   return (
//     // <div className="w-full relative p-4">
//     // <div className="p-4 bg-gray-50 min-h-full flex flex-col w-full relative">
//     //   {/* Search and Add User Button */}
//     //   {/* <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6"> */}
//     //   <div className="bg-white rounded-lg shadow-sm p-4 sticky top-0 z-20">
//     //     <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//     //       <input
//     //         type="text"
//     //         placeholder="Search by name..."
//     //         value={searchQuery}
//     //         onChange={handleSearchChange}
//     //         className="p-2 border rounded w-full md:w-64 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//     //       />
//     //       {/* <button
//     //         onClick={handleAddUser}
//     //         className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded w-full md:w-auto transition duration-200"
//     //       >
//     //         Add User
//     //       </button> */}
//     //       {isAdmin && (
//     //         <button
//     //           onClick={handleAddUser}
//     //           className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded w-full md:w-auto transition duration-200"
//     //         >
//     //           Add User
//     //         </button>
//     //       )}
//     //     </div>
//     //   </div>
//     //   {/* Table for Medium and Larger Screens */}
//     //   {/* <div className="hidden md:block overflow-x-auto"> */}
//     //   <div className="flex-1 overflow-y-auto mt-4">
//     //     <div className="hidden sm:block bg-white rounded-lg shadow-sm">
//     //       <table className="w-full text-left table-fixed">
//     //         {/* <div className="flex-1 overflow-y-auto" style={{ height: "500px" }}>
//     //       <table className="min-w-full divide-y divide-gray-200"> */}
//     //         {/* <thead className="bg-gray-50 sticky top-0"> */}
//     //         <thead className="bg-gray-100 sticky top-0 z-10">
//     //           <tr>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Name
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Email
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Role
//     //             </th>
//     //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Assigned Tasks
//     //             </th>
//     //             {/* <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //               Actions
//     //             </th> */}
//     //             {isAdmin && (
//     //               <th className="w-[15%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//     //                 Actions
//     //               </th>
//     //             )}
//     //           </tr>
//     //         </thead>
//     //         {/* <tbody className="bg-white divide-y divide-gray-200"> */}
//     //         <tbody className="divide-y divide-gray-100">
//     //           {filteredUsers.map((user) => (
//     //             <tr key={user.id} className="text-sm">
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {user.name}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {user.email}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {user.role}
//     //               </td>
//     //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//     //                 {user.assignedTasks.length > 0
//     //                   ? `${user.assignedTasks.length} task${
//     //                       user.assignedTasks.length > 1 ? "s" : ""
//     //                     } assigned`
//     //                   : "No tasks assigned"}
//     //               </td>
//     //               {/* <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
//     //                 <button
//     //                   onClick={() => handleEditPost(user.userId)}
//     //                   className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 transition duration-200"
//     //                 >
//     //                   Edit
//     //                 </button>
//     //                 <button
//     //                   onClick={() => handleDeleteClick(user.userId)}
//     //                   className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition duration-200"
//     //                 >
//     //                   Delete
//     //                 </button>
//     //               </td> */}
//     //               {isAdmin && (
//     //                 <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
//     //                   <button
//     //                     onClick={() => handleEditPost(user.userId)}
//     //                     className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
//     //                   >
//     //                     Edit
//     //                   </button>
//     //                   <button
//     //                     onClick={() => handleDeleteClick(user.userId)}
//     //                     className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
//     //                   >
//     //                     Delete
//     //                   </button>
//     //                 </td>
//     //               )}
//     //             </tr>
//     //           ))}
//     //         </tbody>
//     //       </table>
//     //     </div>
//     //   </div>
//     //   {/* Cards for Small Screens */}
//     //   <div className="md:hidden space-y-4">
//     //     {filteredUsers.map((user) => (
//     //       <div key={user.id} className="bg-white p-4 shadow rounded-lg">
//     //         <h3 className="text-lg font-bold truncate">{user.name}</h3>
//     //         <p className="text-gray-600 text-sm truncate">
//     //           Email: {user.email}
//     //         </p>
//     //         <p className="text-gray-600 text-sm truncate">Role: {user.role}</p>
//     //         <div className="mt-2">
//     //           <p className="text-gray-600 text-sm font-medium">
//     //             Assigned Tasks:
//     //           </p>
//     //           {user.assignedTasks.length > 0
//     //             ? `${user.assignedTasks.length} task${
//     //                 user.assignedTasks.length > 1 ? "s" : ""
//     //               } assigned`
//     //             : "No tasks assigned"}
//     //         </div>
//     //         {isAdmin && (
//     //           <div className="mt-4 flex space-x-2">
//     //             <button
//     //               onClick={() => handleEditPost(user.userId)}
//     //               className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 transition duration-200"
//     //             >
//     //               Edit
//     //             </button>
//     //             <button
//     //               onClick={() => handleDeleteClick(user.userId)}
//     //               className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition duration-200"
//     //             >
//     //               Delete
//     //             </button>
//     //           </div>
//     //         )}
//     //       </div>
//     //     ))}
//     //   </div>
//     //   {/* Delete Confirmation Modal */}
//     //   {modalOpen && (
//     //     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4">
//     //       <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md h-52 flex flex-col justify-between">
//     //         <div>
//     //           <h2 className="text-lg font-bold">Confirm Deletion</h2>
//     //           <p className="text-gray-600 mt-2">
//     //             Are you sure you want to delete this user?
//     //           </p>
//     //         </div>
//     //         <div className="mt-4 flex justify-end space-x-2">
//     //           <button
//     //             onClick={handleDeletePost}
//     //             className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 w-1/3 transition duration-200"
//     //           >
//     //             Delete
//     //           </button>
//     //           <button
//     //             onClick={closeModal}
//     //             className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-1/3 transition duration-200"
//     //           >
//     //             Cancel
//     //           </button>
//     //         </div>
//     //       </div>
//     //     </div>
//     //   )}
//     //   {/* Add User Modal */}
//     //   {isModalOpen && (
//     //     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
//     //     //   <div className="w-[70%] h-[85%] bg-white p-6 rounded-lg">
//     //     //     <AddUserForm
//     //     //       setIsModalOpen={setIsModalOpen}
//     //     //       onUserAdded={handleUserAdded}
//     //     //     />
//     //     //   </div>
//     //     // </div>
//     //     <div>
//     //       <AddUserForm
//     //         setIsModalOpen={setIsModalOpen}
//     //         onUserAdded={handleUserAdded}
//     //       />
//     //     </div>
//     //   )}
//     //   {/* Edit User Modal */}
//     //   {modalOpenEdit && (
//     //     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
//     //     //   <div className="w-[70%] h-[85%] bg-white p-6 rounded-lg">
//     //     //     <EditUserForm
//     //     //       id={userToEdit}
//     //     //       setIsModalOpen={setModalOpenEdit}
//     //     //       onUserAdded={handleUserAdded}
//     //     //     />
//     //     //   </div>
//     //     // </div>
//     //     <div>
//     //       <EditUserForm
//     //         id={userToEdit}
//     //         setIsModalOpen={setModalOpenEdit}
//     //         onUserAdded={handleUserAdded}
//     //       />
//     //     </div>
//     //   )}
//     // </div>
//     <div className="h-full flex flex-col">
//       {/* Static Header */}
//       <h3 className="text-xl font-semibold mb-2 text-gray-900">Users</h3>

//       <div className="py-2 mb-4 flex items-center justify-between gap-4 flex-wrap">
//         <input
//           type="text"
//           placeholder="Search by name..."
//           value={searchQuery}
//           onChange={handleSearchChange}
//           className="p-2 border rounded w-full md:w-64 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
//         />

//         <button
//           onClick={handleAddUser}
//           className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
//         >
//           Add User
//         </button>
//       </div>

//       {/* Scrollable Content */}
//       <div className="flex-1 overflow-y-auto space-y-3">
//         <div className="hidden sm:block bg-white rounded-lg shadow-sm">
//           <table className="w-full text-left table-fixed">
//             <thead className="bg-gray-100 sticky top-0 z-10">
//               <tr>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Name
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Email
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Role
//                 </th>
//                 <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Assigned Tasks
//                 </th>
//                 {/* <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                   Actions
//                 </th> */}
//                 {isAdmin && (
//                   <th className="w-[15%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
//                     Actions
//                   </th>
//                 )}
//               </tr>
//             </thead>
//             {/* Changed divide-gray-100 to divide-gray-300 for more visible dividers */}
//             <tbody className="divide-y divide-gray-300">
//               {filteredUsers.map((user, index) => (
//                 // Added conditional background class for striped rows
//                 <tr
//                   key={user.id}
//                   className={`text-sm ${
//                     index % 2 === 0 ? "bg-white" : "bg-gray-50"
//                   }`}
//                 >
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {user.name}
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {user.email}
//                   </td>
//                   <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
//                     {user.role}
//                   </td>
//                   <td
//                     className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top"
//                     // onClick={() => handleOpenTasksModal(user.userId)}
//                   >
//                     {/* {user.assignedTasks.length > 0
//                       ? `${user.assignedTasks.length} task${
//                           user.assignedTasks.length > 1 ? "s" : ""
//                         } assigned`
//                       : "No tasks assigned"} */}
//                     <span
//                       onClick={() => handleOpenTasksModal(user.userId)}
//                       className="text-indigo-600 hover:text-indigo-800 hover:underline cursor-pointer"
//                     >
//                       {user.assignedTasks.length > 0
//                         ? `${user.assignedTasks.length} task${
//                             user.assignedTasks.length > 1 ? "s" : ""
//                           } assigned`
//                         : "No tasks assigned"}
//                     </span>
//                   </td>
//                   {/* <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
//                   <button
//                     onClick={() => handleEditPost(user.userId)}
//                     className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 transition duration-200"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => handleDeleteClick(user.userId)}
//                     className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition duration-200"
//                   >
//                     Delete
//                   </button>
//                   </td> */}
//                   {isAdmin && (
//                     <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
//                       <button
//                         onClick={() => handleEditPost(user.userId)}
//                         className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
//                       >
//                         Edit
//                       </button>
//                       <button
//                         onClick={() => handleDeleteClick(user.userId)}
//                         className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Cards for Small Screens */}
//         <div className="md:hidden space-y-4">
//           {filteredUsers.map((user) => (
//             <div key={user.id} className="bg-white p-4 shadow rounded-lg">
//               <h3 className="text-lg font-bold truncate">{user.name}</h3>
//               <p className="text-gray-600 text-sm truncate">
//                 Email: {user.email}
//               </p>
//               <p className="text-gray-600 text-sm truncate">
//                 Role: {user.role}
//               </p>
//               <div className="mt-2">
//                 <p className="text-gray-600 text-sm font-medium">
//                   Assigned Tasks:
//                 </p>
//                 {/* {user.assignedTasks.length > 0
//                   ? `${user.assignedTasks.length} task${
//                       user.assignedTasks.length > 1 ? "s" : ""
//                     } assigned`
//                   : "No tasks assigned"} */}
//                 <span
//                   onClick={() => handleOpenTasksModal(user.userId)}
//                   className="text-indigo-600 hover:text-indigo-800 hover:underline cursor-pointer"
//                 >
//                   {user.assignedTasks.length > 0
//                     ? `${user.assignedTasks.length} task${
//                         user.assignedTasks.length > 1 ? "s" : ""
//                       } assigned`
//                     : "No tasks assigned"}
//                 </span>
//               </div>
//               {isAdmin && (
//                 <div className="mt-4 flex space-x-2">
//                   <button
//                     onClick={() => handleEditPost(user.userId)}
//                     className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 transition duration-200"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => handleDeleteClick(user.userId)}
//                     className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition duration-200"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Delete Confirmation Modal */}
//         {modalOpen && (
//           <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4 z-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md h-52 flex flex-col justify-between">
//               <div>
//                 <h2 className="text-lg font-bold">Confirm Deletion</h2>
//                 <p className="text-gray-600 mt-2">
//                   Are you sure you want to delete this user?
//                 </p>
//               </div>
//               <div className="mt-4 flex justify-end space-x-2">
//                 <button
//                   onClick={handleDeletePost}
//                   disabled={isDeleting}
//                   className={`${
//                     isDeleting ? "bg-gray-300" : "bg-red-500 hover:bg-red-600"
//                   } text-white px-4 py-2 rounded w-1/3 transition duration-200`}
//                 >
//                   {isDeleting ? "Deleting..." : "Delete"}
//                 </button>
//                 <button
//                   onClick={closeModal}
//                   className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-1/3 transition duration-200"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {/* Add User Modal */}
//         {isModalOpen && (
//           <div>
//             <AddUserForm
//               setIsModalOpen={setIsModalOpen}
//               onUserAdded={handleUserAdded}
//             />
//           </div>
//         )}

//         {/* Edit User Modal */}
//         {modalOpenEdit && (
//           <div>
//             <EditUserForm
//               id={userToEdit}
//               setIsModalOpen={setModalOpenEdit}
//               onUserAdded={handleUserAdded}
//             />
//           </div>
//         )}

//         {/* show tasks */}
//         {isShowTasks && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//             <div className="bg-white w-full max-w-lg p-6 rounded-md shadow-xl relative">
//               <button
//                 onClick={handleCloseTaskModal}
//                 className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
//               >
//                 ✕
//               </button>

//               <h2 className="text-lg font-semibold mb-4">
//                 Tasks Assigned to {currentUserName}
//               </h2>

//               {selectedTasks.length === 0 ? (
//                 <p className="text-gray-500">No tasks found for this user.</p>
//               ) : (
//                 <ul className="space-y-2 max-h-[300px] overflow-y-auto">
//                   {selectedTasks.map((task) => (
//                     <li key={task.id} className="p-3 border rounded-md">
//                       <h3 className="font-medium">{task.title}</h3>
//                       <p className="text-sm text-gray-600">
//                         {task.description}
//                       </p>
//                       <p className="text-xs text-gray-500 mt-1">
//                         Status: {task.status}
//                       </p>
//                       {task.dueDate && (
//                         <p className="text-xs text-gray-500">
//                           Due: {new Date(task.dueDate).toLocaleDateString()}
//                         </p>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Users;

import React, { useState, useEffect } from "react";
import API from "../Context/api";
import AddUserForm from "./AddUserForm";
import EditUserForm from "./EditUserForm";
import Spinner from "../Helpers/Spinner";
import { useAuth } from "../Context/AuthContext";

// Users component for managing user list, search, and actions (add, edit, delete, view tasks)
function Users() {
  // State declarations
  const [users, setUsers] = useState([]); // List of all users
  const [userToDelete, setUserToDelete] = useState(null); // ID of user to delete
  const [userToEdit, setUserToEdit] = useState(null); // ID of user to edit
  const [loading, setLoading] = useState(true); // Loading state for fetching users
  const [error, setError] = useState(""); // Error message for failed operations
  const [searchQuery, setSearchQuery] = useState(""); // Search input for filtering users
  const [isModalOpen, setIsModalOpen] = useState(false); // Add user modal visibility
  const [modalOpen, setModalOpen] = useState(false); // Delete confirmation modal visibility
  const [modalOpenEdit, setModalOpenEdit] = useState(false); // Edit user modal visibility
  const [isShowTasks, setIsShowTasks] = useState(false); // Tasks modal visibility
  const [isDeleting, setIsDeleting] = useState(false); // Deleting state for user deletion
  const [selectedTasks, setSelectedTasks] = useState([]); // Tasks for selected user
  const [currentUserName, setCurrentUserName] = useState(""); // Name of user for tasks modal

  // Authentication context
  const { user } = useAuth();
  const isAdmin = user?.role === "Admin"; // Check if current user is Admin

  // Fetch all users on component mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await API.get("/users");
        setUsers(response.data);
        console.log(response.data);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch users");
        setLoading(false);
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  // Handlers for user actions
  // Open tasks modal and fetch tasks for a user
  const handleOpenTasksModal = async (userId) => {
    try {
      const res = await API.get(`/users/tasks/${userId}`);
      const user = users.find((u) => u.id === userId);
      setCurrentUserName(user?.name || "User");
      setSelectedTasks(res.data);
      setIsShowTasks(true);
    } catch (err) {
      console.error("Failed to fetch tasks:", err);
      setSelectedTasks([]);
      setIsShowTasks(true);
    }
  };

  // Close tasks modal and reset related state
  const handleCloseTaskModal = () => {
    setIsShowTasks(false);
    setSelectedTasks([]);
    setCurrentUserName("");
  };

  // Open delete confirmation modal
  const handleDeleteClick = (id) => {
    setUserToDelete(id);
    setModalOpen(true);
  };

  // Close delete confirmation modal
  const closeModal = () => {
    setModalOpen(false);
    setUserToDelete(null);
  };

  // Delete a user
  const handleDeletePost = async () => {
    setIsDeleting(true);
    if (userToDelete) {
      try {
        await API.delete(`/users/${userToDelete}`);
        setUsers(users.filter((user) => user.userId !== userToDelete));
        closeModal();
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("Failed to delete user.");
        closeModal();
      } finally {
        setIsDeleting(false);
      }
    }
  };

  // Open edit modal
  const handleEditPost = (id) => {
    setUserToEdit(id);
    setModalOpenEdit(true);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Open add user modal
  const handleAddUser = () => {
    setIsModalOpen(true);
  };

  // Handle adding or editing a user
  const handleUserAdded = (updatedUser) => {
    if (updatedUser.userId === userToEdit) {
      // Edit case: Update existing user
      setUsers(
        users.map((user) =>
          user.userId === updatedUser.userId
            ? { ...user, ...updatedUser }
            : user
        )
      );
    } else {
      // Add case: Append new user with empty assignedTasks
      const newUser = {
        ...updatedUser,
        assignedTasks: updatedUser.assignedTasks || [],
      };
      setUsers((prevUsers) => [...prevUsers, newUser]);
    }
    setIsModalOpen(false);
    setModalOpenEdit(false);
    setUserToEdit(null);
  };

  // Filter users by search query
  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Render loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  // Render error state
  if (error) {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  // Main UI
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <h3 className="text-xl font-semibold mb-2 text-gray-900">Users</h3>

      {/* Search and Add User */}
      <div className="py-2 mb-4 flex items-center justify-between gap-4 flex-wrap">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="p-2 border rounded w-full md:w-64 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />
        <button
          onClick={handleAddUser}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
        >
          Add User
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto space-y-3">
        {/* Table View (Desktop) */}
        <div className="hidden sm:block bg-white rounded-lg shadow-sm">
          <table className="w-full text-left table-fixed">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Name
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Email
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Role
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Assigned Tasks
                </th>
                {isAdmin && (
                  <th className="w-[15%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {filteredUsers.map((user, index) => (
                <tr
                  key={user.id}
                  className={`text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {user.name}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {user.email}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {user.role}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    <span
                      onClick={() => handleOpenTasksModal(user.userId)}
                      className="text-indigo-600 hover:text-indigo-800 hover:underline cursor-pointer"
                    >
                      {user.assignedTasks.length > 0
                        ? `${user.assignedTasks.length} task${
                            user.assignedTasks.length > 1 ? "s" : ""
                          } assigned`
                        : "No tasks assigned"}
                    </span>
                  </td>
                  {isAdmin && (
                    <td className="px-4 py-3 flex gap-2 justify-start items-start flex-wrap">
                      <button
                        onClick={() => handleEditPost(user.userId)}
                        className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteClick(user.userId)}
                        className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Delete
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Card View (Mobile) */}
        <div className="md:hidden space-y-4">
          {filteredUsers.map((user) => (
            <div key={user.id} className="bg-white p-4 shadow rounded-lg">
              <h3 className="text-lg font-bold truncate">{user.name}</h3>
              <p className="text-gray-600 text-sm truncate">
                Email: {user.email}
              </p>
              <p className="text-gray-600 text-sm truncate">
                Role: {user.role}
              </p>
              <div className="mt-2">
                <p className="text-gray-600 text-sm font-medium">
                  Assigned Tasks:
                </p>
                <span
                  onClick={() => handleOpenTasksModal(user.userId)}
                  className="text-indigo-600 hover:text-indigo-800 hover:underline cursor-pointer"
                >
                  {user.assignedTasks.length > 0
                    ? `${user.assignedTasks.length} task${
                        user.assignedTasks.length > 1 ? "s" : ""
                      } assigned`
                    : "No tasks assigned"}
                </span>
              </div>
              {isAdmin && (
                <div className="mt-4 flex space-x-2">
                  <button
                    onClick={() => handleEditPost(user.userId)}
                    className="bg-indigo-500 text-white px-3 py-1 rounded hover:bg-indigo-600 transition duration-200"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDeleteClick(user.userId)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition duration-200"
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Modals */}
        {/* Delete Confirmation Modal */}
        {modalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-4 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md h-52 flex flex-col justify-between">
              <div>
                <h2 className="text-lg font-bold">Confirm Deletion</h2>
                <p className="text-gray-600 mt-2">
                  Are you sure you want to delete this user?
                </p>
              </div>
              <div className="mt-4 flex justify-end space-x-2">
                <button
                  onClick={handleDeletePost}
                  disabled={isDeleting}
                  className={`${
                    isDeleting ? "bg-gray-300" : "bg-red-500 hover:bg-red-600"
                  } text-white px-4 py-2 rounded w-1/3 transition duration-200`}
                >
                  {isDeleting ? "Deleting..." : "Delete"}
                </button>
                <button
                  onClick={closeModal}
                  className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 w-1/3 transition duration-200"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add User Modal */}
        {isModalOpen && (
          <div>
            <AddUserForm
              setIsModalOpen={setIsModalOpen}
              onUserAdded={handleUserAdded}
            />
          </div>
        )}

        {/* Edit User Modal */}
        {modalOpenEdit && (
          <div>
            <EditUserForm
              id={userToEdit}
              setIsModalOpen={setModalOpenEdit}
              onUserAdded={handleUserAdded}
            />
          </div>
        )}

        {/* Tasks Modal */}
        {isShowTasks && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white w-full max-w-lg p-6 rounded-md shadow-xl relative">
              <button
                onClick={handleCloseTaskModal}
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
              >
                ✕
              </button>
              <h2 className="text-lg font-semibold mb-4">
                Tasks Assigned to {currentUserName}
              </h2>
              {selectedTasks.length === 0 ? (
                <p className="text-gray-500">No tasks found for this user.</p>
              ) : (
                <ul className="space-y-2 max-h-[300px] overflow-y-auto">
                  {selectedTasks.map((task) => (
                    <li key={task.id} className="p-3 border rounded-md">
                      <h3 className="font-medium">{task.title}</h3>
                      <p className="text-sm text-gray-600">
                        {task.description}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        Status: {task.status}
                      </p>
                      {task.dueDate && (
                        <p className="text-xs text-gray-500">
                          Due: {new Date(task.dueDate).toLocaleDateString()}
                        </p>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Users;
